document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".vacations-grid__list ul li[data-id]");
  const descriptions = document.querySelectorAll('.vacations-grid__content .splide__slide');

  if (!items.length) return;

  function activateVacancy(id) {
    descriptions.forEach((desc) => {
      desc.style.display = "none";
    });

    items.forEach((item) => {
      item.classList.remove("active");
    });

    const activeBlock = document.getElementById("vacation-" + id).parentNode;
    if (activeBlock) {
      activeBlock.style.display = "block";
    }

    const activeItem = document.querySelector('li[data-id="' + id + '"]');
    if (activeItem) {
      activeItem.classList.add("active");
    }
  }

  items.forEach((item) => {
    item.addEventListener("click", function () {
      const id = this.dataset.id;
      activateVacancy(id);
    });
  });

  const firstId = items[0].dataset.id;
  activateVacancy(firstId);

  const sliderElement = document.querySelector('.vacations-slider');

  if (!sliderElement || typeof Splide !== 'undefined') {
    let splideObj = null;

    function initSlider() {
      if (!splideObj) {
        descriptions.forEach((desc) => {
          desc.style.display = "";
        });

        splideObj = new Splide(sliderElement, {
          type: 'loop',
          perPage: 1,
          gap: 20,
          focus: 'center',
          padding: '20%',
          arrows: false,
          pagination: false,
          autoplay: false,
          breakpoints: {
            900: {
              padding: '10%',
            },
            800: {
              padding: '0%',
            }
          }
        });

        splideObj.mount();
      }
    }

    function destroySlider() {
      if (splideObj) {
        splideObj.destroy();
        splideObj = null;

        descriptions.forEach((desc) => {
          desc.style.display = "none";
        });
        activateVacancy(firstId);
      }
    }

    function handleResponsiveSlider() {
      if (window.innerWidth < 1200) {
        if (!splideObj) {
          initSlider();
        }
      } else {
        if (splideObj) {
          destroySlider();
        }
      }
    }

    handleResponsiveSlider();

    window.addEventListener('resize', () => {
      handleResponsiveSlider();
    });
  }
});